import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {EditorConfiguration} from "../core/config/editor-configuration";

@JsonObject()
export class ApplicationPopupConfiguration {

    /**
     * If collapse Button is visible
     */
    @JsonProperty()
    declare disabled: boolean;

    /**
     * Configuration for editor to draw features to the map
     */
    @JsonProperty()
    declare editor: EditorConfiguration;

    constructor() {}
}
